/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/SubscriptionDetails/Digital/History/theme';

export const SubscriptionDetailsDigitalHistoryTheme = theme;
